/**
 * Zenco (external Power of Attorney partner) configuration.
 *
 * KareHero members whose organization is one of the partner orgs listed in
 * ZENCO_PARTNER_SLUGS get their first POA application free and are routed to
 * a partner-specific landing page on Zenco. Everyone else goes to the default
 * paid landing page.
 */

export const ZENCO_BASE_URL = 'https://online.zenco.com/Start/KareHero/Landing';

export const ZENCO_DEFAULT_URL = `${ZENCO_BASE_URL}/Index`;

// Keys are account.organization.name values; values are Zenco URL slugs.
export const ZENCO_PARTNER_SLUGS: Record<string, string> = {
  'British Airways': 'BritishAirways',
  CIPD: 'CIPD',
  'Osborne Clark': 'OsborneClark',
  RSPCA: 'Rspca',
  TSB: 'Tsb',
  'Witherslack Group': 'WitherSlackGroup',
};

/**
 * Returns true if the user qualifies for a free first POA through Zenco.
 * Either via partner organization membership or an account-level entitlement.
 */
export const isFirstPoaFree = (
  orgName?: string | null,
  isPoaFreeReview?: boolean,
): boolean => {
  if (isPoaFreeReview) return true;
  return !!(orgName && orgName in ZENCO_PARTNER_SLUGS);
};

/**
 * @deprecated Use isFirstPoaFree instead, which also checks account-level entitlement.
 */
export const isFirstPoaFreeForOrg = (orgName?: string | null): boolean => {
  return !!(orgName && orgName in ZENCO_PARTNER_SLUGS);
};

/**
 * Returns the Zenco landing URL for the given organization name. Partner orgs
 * get their branded landing page; everyone else gets the default paid page.
 */
export const getZencoUrlForOrg = (orgName?: string | null): string => {
  if (orgName && orgName in ZENCO_PARTNER_SLUGS) {
    return `${ZENCO_BASE_URL}/${ZENCO_PARTNER_SLUGS[orgName]}`;
  }
  return ZENCO_DEFAULT_URL;
};

/** Official GOV.UK service for applying for an LPA directly (no legal review). */
export const GOV_UK_LPA_URL =
  'https://www.gov.uk/power-of-attorney/make-lasting-power';
